import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fablab',
  templateUrl: './fablab.component.html',
  styleUrls: ['./fablab.component.scss']
})
export class FablabComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
